import { render, staticRenderFns } from "./cardWait.vue?vue&type=template&id=5f99edc8&scoped=true"
import script from "./cardWait.vue?vue&type=script&lang=js"
export * from "./cardWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f99edc8",
  null
  
)

export default component.exports